export default __webpack_public_path__ + "static/media/suited-boy.acb5bc48.png";